import type { ComponentProps } from 'react';
import { useCallback } from 'react';
import { useTracking } from 'react-tracking';

import { Heading, Grid } from '@simplywallst/ui-core';

import {
  PortfolioDropdown,
  UnauthenticatedPortfolioDropdown,
} from '../PortfolioDropdown';

import type { Portfolio } from '@/hooks/portfolio/usePortfolio';
import useUser from '@/hooks/useUser';

type Props = ComponentProps<typeof Grid> & {
  portfolio?: Portfolio;
};

export const PortfolioPageHeader = ({
  portfolio,
  children,
  ...props
}: Props) => {
  const { data: user } = useUser();
  const { trackEvent } = useTracking({ type: 'track' });

  const trackDropdownClick = useCallback(() => {
    trackEvent({
      modifier: 'myPortfolioDropDown',
      // Force subject to be page
      subject: 'page',
      action: 'click',
    });
  }, [trackEvent]);

  return (
    <Grid
      as="header"
      data-cy-id="portfolio-header"
      data-testid="portfolio-header"
      templateRows="auto"
      templateColumns="auto min-content"
      templateColumnsMd="auto auto"
      justifyContentMd="space-between"
      alignItems="center"
      paddingX="x2"
      paddingXLg="x0"
      {...props}
    >
      {user.loggedIn ? (
        <PortfolioDropdown
          portfolioId={portfolio?.id ?? null}
          onClick={trackDropdownClick}
        >
          <Heading as="h1" typography="megaStrong" isTruncated>
            {portfolio?.name ?? 'My Portfolio'}
          </Heading>
        </PortfolioDropdown>
      ) : (
        <UnauthenticatedPortfolioDropdown
          portfolioId={portfolio?.id ?? null}
          onClick={trackDropdownClick}
        >
          {' '}
          <Heading as="h1" typography="megaStrong" isTruncated>
            {portfolio?.name ?? 'My Portfolio'}
          </Heading>
        </UnauthenticatedPortfolioDropdown>
      )}
      {children}
    </Grid>
  );
};
